import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthGuard } from './lib/auth-guard';
import { EventsPage } from './pages/events-page';
import { ArenaEnginePage } from './pages/arena-engine-page';

export default function App() {
  return (
    <AuthGuard>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EventsPage />} />
          <Route path="/events/:eventId" element={<ArenaEnginePage />} />
        </Routes>
      </BrowserRouter>
    </AuthGuard>
  );
}
